import { Zap, Battery } from "lucide-react";

export default function Speed({
  averageSpeed,
  maxSpeed,
}: {
  averageSpeed: number;
  maxSpeed: number;
}) {
  return (
    <div className="w-full rounded-lg border border-border bg-white p-4 shadow-md">
      <h2 className="mb-4 text-xl font-semibold text-card-foreground">
        Potência
      </h2>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Battery
              fill="currentColor"
              className="h-5 w-5 text-blue-500"
              aria-hidden="true"
            />
            <span className="text-sm font-semibold text-gray-600">
              Potência Média
            </span>
          </div>
          <span className="text-lg font-bold text-gray-800">
            {Math.round(averageSpeed)} kW
          </span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Zap
              fill="currentColor"
              className="h-5 w-5 text-yellow-500"
              aria-hidden="true"
            />
            <span className="text-sm font-semibold text-gray-600">
              Potência Máxima
            </span>
          </div>
          <span className="text-lg font-bold text-gray-800">
            {Math.round(maxSpeed)} kW
          </span>
        </div>
      </div>
    </div>
  );
}
